import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TFleet } from 'features/routing/types/fleet';
import { TLogisticsFleet } from 'features/routing/types/logistics';

import { TCharterForm, TLogisticsCharterForm } from '../forms/charter';

export type TCharterState = {
  bookingDetails?: TCharterForm;
  fleets?: TFleet[];
  selectedFleet?: TFleet;

  logisticsCharterBookingDetails?: TLogisticsCharterForm;
  logisticsFleet?: TLogisticsFleet[];
  selectedLogisticsFleet?: TLogisticsFleet;
};

const createCharterSlice = (initialState: TCharterState) =>
  createSlice({
    name: 'charter',
    initialState,
    reducers: {
      setFleets(state, { payload }: PayloadAction<TFleet[]>) {
        state.fleets = payload;
      },

      setLogisticsFleets(state, { payload }: PayloadAction<TLogisticsFleet[]>) {
        state.logisticsFleet = payload;
      },

      clearCharter(state) {
        delete state.bookingDetails;
        delete state.fleets;
        delete state.selectedFleet;

        delete state.logisticsCharterBookingDetails;
        delete state.logisticsFleet;
        delete state.selectedLogisticsFleet;
      },

      setBookingDetails(state, { payload }: PayloadAction<TCharterForm>) {
        state.bookingDetails = payload;
      },

      setLogisticsBookingDetails(
        state,
        { payload }: PayloadAction<TLogisticsCharterForm>
      ) {
        state.logisticsCharterBookingDetails = payload;
      },

      setFleet(state, { payload }: PayloadAction<TFleet>) {
        state.selectedFleet = payload;
      },

      setLogisticsFleet(state, { payload }: PayloadAction<TLogisticsFleet>) {
        state.selectedLogisticsFleet = payload;
      },

      clearFleet(state) {
        delete state.selectedFleet;
        delete state.selectedLogisticsFleet;
      },
    },
  });

const charterSlice = createCharterSlice({});
export const {
  clearCharter,
  clearFleet,
  setBookingDetails,
  setFleet,
  setFleets,
  setLogisticsBookingDetails,
  setLogisticsFleet,
  setLogisticsFleets,
} = charterSlice.actions;
export default charterSlice.reducer;
